// The page never zooms (#290): the viewport meta says so (user-scalable=no), but Safari ignores it. A pinch that began
// with a finger on a button beside a map zoomed the whole page, and then the map caught every pinch, so there was no way
// back and the whole app stayed zoomed (seen in the phone's log, 16 Oct 2026). Safari's own gesture events are cancelled
// (Leaflet's pinch on a map uses touch events and keeps working), a double tap no longer zooms (touch-action:
// manipulation on the page), and a page that is zoomed after all (an older tab) is put back: Safari takes the zoom back
// to 1 when the viewport meta is written again.
export default (function () {
  var stop = function stop(e) {
    return e.preventDefault();
  };

  document.addEventListener('gesturestart', stop, {
    passive: false
  });
  document.addEventListener('gesturechange', stop, {
    passive: false
  });
  document.documentElement.style.touchAction = 'manipulation';
  var vv = window.visualViewport;
  var meta = document.querySelector('meta[name="viewport"]');
  if (!vv || !meta) return;
  var content = meta.getAttribute('content');
  var timer = null;

  var unzoom = function unzoom() {
    if (vv.scale <= 1.01) return;
    clearTimeout(timer);
    timer = setTimeout(function () {
      meta.setAttribute('content', content + ', maximum-scale=1.0');
      setTimeout(function () {
        return meta.setAttribute('content', content);
      }, 50);
    }, 150);
  };

  vv.addEventListener('resize', unzoom);
  unzoom();
});